let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("fZt2F"), load("hhss7"), load("kpHRm")]).then(() => parcelRequire('3w3bV'));